import { DOMAIN_TYPES } from "./domainTypes";

export const EducationTemplate = ({ children }) => (
  <div
    className="education-cart"
    style={{
      backgroundColor: "#f8f4e8",
      color: "#195790",
      fontFamily: "'Georgia', serif"
    }}
  >
    {children}
  </div>
);

export const InstitutionTemplate = ({ children }) => (
  <div
    className="institution-cart"
    style={{
      backgroundColor: "#f0f8ff",
      color: "#003366",
      fontFamily: "'Arial', sans-serif"
    }}
  >
    {children}
  </div>
);

export const RetailTemplate = ({ children }) => (
  <div
    className="retail-cart"
    style={{
      backgroundColor: "#fffaf0",
      color: "#8b0000",
      fontFamily: "'Helvetica', sans-serif"
    }}
  >
    {children}
  </div>
);

export const FlexTemplate = ({ children }) => (
  <div
    className="flex-cart"
    style={{
      backgroundColor: "#f5f5f5",
      color: "#333",
      fontFamily: "'Segoe UI', sans-serif"
    }}
  >
    {children}
  </div>
);

export const WaasTemplate = ({ children }) => (
  <div
    className="waas-template"
    style={{
      backgroundColor: "#f8fafc",
      color: "#1e293b",
      fontFamily: "'Inter', sans-serif"
    }}
  >
    {children}
  </div>
);

export const getTemplateByDomain = (domain) => {
  switch (domain) {
    case DOMAIN_TYPES.EDUCATION:
      return EducationTemplate;
    case DOMAIN_TYPES.INSTITUTION:
      return InstitutionTemplate;
    case DOMAIN_TYPES.RETAIL:
      return RetailTemplate;
    case DOMAIN_TYPES.FLEX_OFFICE:
      return FlexTemplate;
    case DOMAIN_TYPES.WAAS:
      return WaasTemplate;
    default:
      return RetailTemplate;
  }
};
